<template>
  <div class="page">
    <div class="echartsContainer" ref="echarts"></div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import { statisticdata } from "@/api/login/login";
export default {
  data () {
    return {
      myChart: null,
      option: {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        },
        grid: {
          left: "8%",
          top: "15%"
        },
        title: {
          text: "财务统计",
          left: "5%"
        },
        legend: {
          data: ["对外付款统计", "对外收款统计", "红包统计", "领取红包统计"]
        },
        toolbox: {
          show: true,
          orient: "vertical",
          left: "right",
          top: "center",
          feature: {
            mark: { show: true },
            dataView: { show: true, readOnly: false },
            magicType: { show: true, type: ["line", "bar", "stack"] },
            restore: { show: true },
            saveAsImage: { show: true }
          }
        },
        xAxis: {
          type: "category",
          axisTick: { show: false },
          data: ["8-1", "8-2", "8-3", "8-4", "8-5"]
        },
        yAxis: [
          {
            type: "value"
          }
        ],
        series: [
          {
            name: "对外付款统计",
            type: "bar",
            barGap: 0,
            emphasis: {
              focus: "series"
            },
            data: [320, 332, 301, 334, 390]
          },
          {
            name: "对外收款统计",
            type: "bar",
            emphasis: {
              focus: "series"
            },
            data: [220, 182, 191, 234, 290]
          },
          {
            name: "红包统计",
            type: "bar",
            emphasis: {
              focus: "series"
            },
            data: [150, 232, 201, 154, 190]
          },
          {
            name: "领取红包统计",
            type: "bar",
            emphasis: {
              focus: "series"
            },
            data: [150, 232, 201, 154, 190]
          }
        ]
      },
      res: {}
    };
  },
  mounted () { },
  created () {
    this.getdata();
    this.init();
  },
  methods: {
    getdata () {
      statisticdata().then(res => {
        if (res.code == 200) {
          this.res = res;
          this.init();
        }
      });
    },
    init () {
      // this.$nextTick(() => {
      if (this.$refs.echarts) {
        this.setOption();
        if (this.myChart) {
          this.myChart.clear();
        }
        this.myChart = echarts.init(this.$refs.echarts);
        this.option && this.myChart.setOption(this.option);
      }
      // });
    },
    setOption () {
      this.option.xAxis.data = this.res.data.times;
      this.option.series[0].data = this.res.data.salary_money;
      this.option.series[1].data = this.res.data.external_money;
      this.option.series[2].data = this.res.data.redpack_money;
      this.option.series[3].data = this.res.data.redpack_money_lq;
    }
  },
  components: {}
};
</script>

<style lang='scss' scoped>
.page {
  height: auto !important;
}
.echartsContainer {
  width: 1400px;
  height: 600px;
  margin-top: 20px;
}
</style>
